import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanAccessGuard } from './app-can-access-guard.routing';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('app/website/modules/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'app',
    canActivate: [CanAccessGuard],
    loadChildren: () => import('./website/modules/dashboard/dashboard.module').then((m) => m.DashboardModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./website/modules/profile/account/account.module').then((m) => m.AccountModule),
    outlet: 'settings'
  },
  {
    path: 'password',
    loadChildren: () =>
      import('./website/modules/dashboard/change-password/hf-change-password.module').then(
        (m) => m.HfChangePasswordModule
      ),
    outlet: 'settings'
  },
  {
    path: 'debug',
    loadChildren: () => import('app/website/modules/debug/debug.module').then((m) => m.DebugModule)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always'
      // enableTracing: true
    })
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {}
